import styled from 'styled-components';

const StyledCancelButton = styled.span`
  margin-left: 10px;
`;

export { StyledCancelButton };
